import React from 'react';

function Contact() {
    return (
        <div className='w-full min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6'>
            <div className='bg-white shadow-lg rounded-2xl p-6 max-w-lg text-center'>
                <h1 className='text-3xl font-bold text-blue-600 mb-4'>Arya Senior College, Manjari</h1>
                <p className='text-gray-700 mb-2'>At/Post: Manjari, Tal: Rahuri, Dist: Ahilyanagar,</p>
                <p className='text-gray-700 mb-2'>State: Maharashtra, India, Pin Code: 413705</p>
                <p className='text-gray-700 mt-4 mb-2'>
                    Contact No: <a href='tel:+919822350535' className='text-blue-500 font-medium'>+91 98223 50535</a>
                </p>
                <p className='text-gray-700 mb-4'>
                    Mail Id: <a href='mailto:aryasenior23@gmail.com' className='text-blue-500 font-medium'>aryasenior23@gmail.com</a>
                </p>
                <a  href="https://bcud.unipune.ac.in/utilities/college_search/CAAA021740_ENG/Pune_University_College"
                 className='text-green-600 font-semibold mt-4 no-underline'>
                    SAVITRIBAI PHULE PUNE UNIVERSITY APPROVED
                    </a>

            </div>
        </div>
    );
}

export default Contact;
